import { Credential, UserAccount } from '../types/user';
import axiosClient from './axiosClient';

export interface LoginFormData {
  username: string;
  password: string;
}

export interface ChangePasswordFormData {
  id: string;
  oldPassword: string;
  password: string;
  confirmPassword: string;
}

export interface ForgotPasswordFormData {
  email: string;
}

export interface ResetPasswordFormData {
  id: string;
  password: string;
  confirmPassword: string;
}

export interface AuthService {
  login: (data: LoginFormData) => Promise<(UserAccount & Credential) | null>;
  logout: () => Promise<void>;
  getMe: () => Promise<UserAccount>;
  refreshToken: (data?: { refreshToken: string }) => Promise<Credential>;
}

export const authQueryKeys = {
  all: ['auth'],
  getMe: () => [...authQueryKeys.all, 'getMe'],
};

const authService: AuthService = {
  login: async (data) => await axiosClient.post('/user/auth/sign-in', data),
  logout: async () => await axiosClient.post('/user/auth/sign-out'),
  getMe: async () => await axiosClient.get('/user/auth/me'),
  refreshToken: async (data) => await axiosClient.post('/user/auth/refresh-token', data),
};

export default authService;
